import { useState, useEffect } from "react";
import { Command, CommandGroup, CommandItem } from "@/components/ui/command";
import { supabase } from "@/integrations/supabase/client";

interface MentionSuggestionsProps {
  searchTerm: string;
  onSelect: (username: string) => void;
  position: { top: number; left: number };
}

export const MentionSuggestions = ({ searchTerm, onSelect, position }: MentionSuggestionsProps) => {
  const [users, setUsers] = useState<{ username: string }[]>([]);

  useEffect(() => {
    const fetchUsers = async () => {
      if (searchTerm.length < 1) return;

      const { data } = await supabase
        .from('profiles')
        .select('username')
        .ilike('username', `${searchTerm}%`)
        .limit(5);

      setUsers(data || []);
    };

    fetchUsers();
  }, [searchTerm]);

  if (!users.length) return null;

  return (
    <div
      className="absolute z-50 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700"
      style={{ top: position.top, left: position.left }}
    >
      <Command>
        <CommandGroup>
          {users.map((user) => (
            <CommandItem
              key={user.username}
              onSelect={() => onSelect(user.username)}
              className="cursor-pointer"
            >
              <span>@{user.username}</span>
            </CommandItem>
          ))}
        </CommandGroup>
      </Command>
    </div>
  );
};